export default {
    permissionCode: [],
    expandMuneBoolen: true,
    noPadding: false,
    paddingValue: false,
    fixPadding: false,
};
